import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import ReactTable from "react-table";
import {getData} from "./utils";
import 'react-table/react-table.css'
import './App.css';
const url = 'https://itxs.ro/clients/terra/customReports/getApiData';
class App extends Component {
    requestData = (pageSize, page, sorted, filtered) => {
        return new Promise((resolve, reject) => {
            let report_params = {nolimit:0,page:page+1,ppp:pageSize};
            if(sorted.length){
                report_params['sortField'] = sorted[0]['id'];
                if(sorted[0]['desc']){
                    report_params['sortField'] += ':DESC';
                } else {
                    report_params['sortField'] += ':ASC';
                }
            }
            if(filtered.length){
                report_params['attributesByWord'] = {};
                for(let i=0;i<filtered.length;i++) {
                    if(!report_params['attributesByWord'][filtered[i]['id']]){
                        report_params['attributesByWord'][filtered[i]['id']] = [];
                    }
                    report_params['attributesByWord'][filtered[i]['id']].push(filtered[i]['value']);
                }
            }

            let params = {report_key:4,report_params:report_params,api_key:123};
            // You must return an object containing the rows of the current page, and optionally the total pages number.
            getData(this,url,params);


            resolve();
        });
    };
    fetchData(state, instance) {
        // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
        // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
        this.setState({ loading: true });
        // Request the data however you want.  Here, we'll use our mocked service we created earlier
        console.log(state);
        this.requestData(
            state.pageSize,
            state.page,
            state.sorted,
            state.filtered
        ).then(() => {
            // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
            this.setState({
                loading: false
            });
        });
    }
    constructor(props) {
        super(props);
        this.state = {columns : [],data:[],pages:0};
        this.fetchData = this.fetchData.bind(this);
        this.requestData = this.requestData.bind(this);
    }

    render() {


      return (
          <div>
              <Button bsStyle="primary" onClick ={() =>
              {
                  let columns=this.state.columns;
                  columns[0].Header='Nume';
                  this.setState({columns:columns});
              }
              }>Change</Button>
          <ReactTable
      data={this.state.data}
      columns={this.state.columns}
      pages={this.state.pages}
      manual
      filterable
      style={{
          height: "80vh" // This will force the table body to overflow and scroll, since there is not enough room
      }}
      onFetchData={this.fetchData}
          />
          </div>
      );
  }
}

export default App;
